import { MarkdownPreview } from '../../';
import { Box, VStack } from '@terra/ui-styled-system';
import { SectionTitle } from './SectionTitle';

type MarkdownSectionProps = {
  title: string;
  source: string;
  language?: string | null;
};

export function MarkdownSection({
  title,
  source,
  language = '',
}: MarkdownSectionProps) {
  const markdownSource =
    language === null
      ? `\`\`\`\n${source}\n\`\`\``
      : language && language !== ''
        ? `\`\`\`${language}\n${source}\n\`\`\``
        : source;

  return (
    <VStack alignItems="stretch" gap={2} width="100%">
      <SectionTitle>{title}:</SectionTitle>
      <Box w="full" borderRadius="md">
        <MarkdownPreview source={markdownSource} compact />
      </Box>
    </VStack>
  );
}
